import React, {useEffect, useRef} from "react";
import PropTypes from 'prop-types';
const IntervalTimer = (props) => {
    const {component, doActions} = props;
    const {properties, events} = component;
    //create ref for interval,
    const intervalID = useRef()


    useEffect(() => {
        //
        if(events && events.length) {
            if (events[0].event === 'onTick') {
                doActions(events[0].actions)
            }
        }

        //start interval
        intervalID.current = setInterval(() => {
            if(events && events.length) {
                if (events[0].event === 'onTick') {
                    doActions(events[0].actions)
                }
            }
        }, Number(properties.interval) * 1000)

        return () => {
            //remove interval on unmount
            clearInterval(intervalID.current)
            intervalID.current = null;
        }
    }, [])


    return <></>
}

IntervalTimer.propTypes = {
    component: PropTypes.object,
    doActions: PropTypes.func
}

export default IntervalTimer;